import { WhyChooseUs, Services } from "@/components/WhyAndServices";
import useDocumentMeta from "@/lib/useDocumentMeta";

export default function ServicesPage() {
    useDocumentMeta({
        title: "Услуги · Konstantin Mobile — Детайлинг, Диагностика, Внос",
        description:
            "Премиум автомобилни услуги от Konstantin Mobile: внос на автомобили по поръчка, детайлинг, диагностика, регистрация и застраховане в Петрич.",
        path: "/services",
    });
    return (
        <main data-testid="services-page" className="pt-24">
            <WhyChooseUs />
            <Services />
        </main>
    );
}
